<template>
  <footer class="footer">
    <div class="footer-content">
      <!-- <p class="firstLine">
        ควบคุมโดยสำนักงานคณะกรรมการการธนาคารแห่งรัฐแห่งประเทศไทยและสำนักงานคณะกรรมการกำกับหลักทรัพย์
      </p> -->
      <p class="secondLine">Copyright © Tamogi, S.A. de C.V., Sofom, E.N.R.</p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #02033b;
  color: white;
  min-width: 1400px;
  max-width: 1620px;
  height: 90px;
}

.footer-content {
  font-size: 22px;
  text-align: center;
  margin: 0 auto;
  font-family: Poppins-Regular;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
}
.firstLine {
  width: 1270px;
  height: 20px;
  font-size: 24px;
  font-family: SF Pro, SF Pro;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
}
.secondLine {
  width: 1098px;
  height: 20px;
  font-size: 24px;
  font-family: SF Pro-Regular;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
}
</style>
